module.exports = __webpack_public_path__ + "static/nft-market-website-plp-33aacada22c6ac2f2591a0f5b3bf4b08.png";